import type { Rect } from "./panel-marks";

/**
 * The ink of a text block, one rect per rendered line, relative to `origin`.
 *
 * A text element's own box is the full column, which on the hero panel is the
 * whole panel width: using it would rule out nearly every seat. A Range over
 * the contents reports the line boxes the glyphs actually occupy, so a mark can
 * sit beside a short second line.
 */
export function inkRects(el: Element, origin: DOMRect): Rect[] {
  const range = document.createRange();
  range.selectNodeContents(el);
  const rects = Array.from(range.getClientRects());
  range.detach();
  const source = rects.length ? rects : [el.getBoundingClientRect()];
  return source
    .filter((r) => r.width > 0 && r.height > 0)
    .map((r) => ({
      x: r.left - origin.left,
      y: r.top - origin.top,
      width: r.width,
      height: r.height,
    }));
}

/** Plain box of an element, relative to `origin`. Used for the wordmark. */
export function boxRect(el: Element, origin: DOMRect): Rect {
  const r = el.getBoundingClientRect();
  return {
    x: r.left - origin.left,
    y: r.top - origin.top,
    width: r.width,
    height: r.height,
  };
}
